import { Donuz } from "@/donuz-js/Donuz";
import facebookLogin from "facebook-login-vuejs";

// @ is an alias to /src
export default {
  name: "invite",
  components: {
    facebookLogin
  },
  data() {
    return {
      email: "",
      fbId: 0,
      access_token: "",
      post: ""
    };
  },
  async created() {
    if(!this.ESTABELECIMENTO.pode_compartilhar){
      this.$route.push(this.$route.params.slug + "/");
    }

    window.fbAsyncInit = function () {
      FB.init({
        appId: "209597896191496",
        status: true,
        cookie: true,
        xfbml: true,
        oauth: true,
        version: "v3.3"
      });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
    this.post = "https://www.donuz.com.br";
  },
  updated() {
    var elems = document.querySelectorAll("select");
    var instances = M.FormSelect.init(elems);
    window.M.updateTextFields();
  },
  methods: {
    share: async function () {
      let dados = {
        acao: "pontuar",
        estabelecimento_id: this.ESTABELECIMENTO.id,
        cliente_id: this.client.id_cliente,
        cpf_codigo: this.client.cpf
      };

      let id_admin = this.ESTABELECIMENTO.id;

      FB.ui({
        method: "share",
        href: "http://pts.vc/usr/" + this.ESTABELECIMENTO.id
      }, async function (response) {
        if (response && !response.error_message) {
          let resp = await Donuz.share.getHash(
            sessionStorage.getItem(btoa("tokenCliente")),
            id_admin
          );
          if (resp.status == 200) {
            let res = await Donuz.share.pontuate(dados);
            alert(res.status == 200 ? "Sucesso" : res.mensagem);
          } else {
            alert("Erro!!!\nTente novamente");
          }
        } else {
          alert("Erro!!!\nTente novamente");
        }
      }
      );
    },
    twitter: function () {
      fetch("https://twitter.com/intent/tweet")
        .then(data => alert("ok"))
    }
  }
};
